import { faCircleNotch } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import OtpDialog from "components/reusable/OtpDialog";
import Toolbar from "components/Toolbar";
import dayjs from "dayjs";
import useToastContext from "hooks/useToastContext";
import { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { useNavigate, useParams } from "react-router-dom";
import { apiGet, apiPost } from "utils/apiFetch";
import pathObj from "utils/apiPath";

function SmartfinPaymentDetails() {
  const { orderNumber } = useParams();

  const { t } = useTranslation();
  const navigate = useNavigate();
  const notification = useToastContext();
  const {
    register,
    handleSubmit,
  } = useForm({ mode: "onChange", shouldFocusError: true, defaultValues: {} });

  const [paymentDetails, setPaymentDetails] = useState(null);

  const [loading, setLoading] = useState(false);
  const [requestBody, setRequestBody] = useState({});

  const [showOtpDialog, setShowOtpDialog] = useState(false);

  const getPaymentDetails = async () => {
    try {
        var response = await apiGet(`${pathObj.pendingSmartfinTransactionDetails}?id=${orderNumber}`);
        if (response.data.success) {
          setPaymentDetails(response.data.results);
        } else {
          notification.error(response.data.message);
          navigate(-1);
        }
    } catch (err) {}
  };

  useEffect(() => {
    getPaymentDetails();
  }, []);

  const onSubmit = async (data) => {
    setLoading(true);
    try {
      const requestBody = {
        id: orderNumber,
        comment: data.comment,
      };
      setRequestBody(requestBody);
      const res = await apiPost(pathObj.pendingSmartfinTransactionSendOTP, requestBody);
      if (res.data.success) {
        setShowOtpDialog(true);
      } else {
        notification.error(res.data.message);
      }
    } catch (err) {}
    setLoading(false);
  };

  if (!paymentDetails) {
    return (
      <>
        <Toolbar title={t("O_DETAILS")} showBackBtn={true} />
        <div className="flex w-full justify-center mt-5">
          <FontAwesomeIcon icon={faCircleNotch} className="text-xl animate-spin h-[15rem]" />
        </div>
      </>
    );
  }

  return (
    <>
      <Toolbar title={t("O_DETAILS")} showBackBtn={true} />
      <form onSubmit={handleSubmit(onSubmit)} className="flex flex-col w-full justify-center items-center">
        <div className="px-4 pb-4 rounded-3xl h-full w-full md:w-[25rem]">
          <div className="mt-2 mx-2">
            <div className="bg-card flex justify-start gap-5 p-[1rem]">
              <img src="/images/smartfin.png" className="h-[2rem]" alt="SMARTFIN Logo" />
              <div className="font-medium text-start text-white">
                <div className="grid grid-cols-2 text-xs w-full">
                  <div className="col-span-1">{t("PROVIDER")}</div>
                  <div className="col-span-1 text-gray-500 text-end">SMARTFIN</div>

                  <div className="col-span-1">{t("ORDER_DATE")}</div>
                  <div className="col-span-1 text-gray-500 text-end">{dayjs(paymentDetails.date).format("DD/MM/YYYY")}</div>

                  <div className="col-span-1">{t("ORDER_NUMBER")}</div>
                  <div className="col-span-1 text-gray-500 text-end">{paymentDetails.orderNr}</div>
                </div>
              </div>
            </div>


            <div className="text-lg font-medium  mt-5 mb-2">{t("AMOUNT")}</div>
            <div className="bg-card p-4 rounded-lg">
              <div className="flex justify-start gap-3 items-center">
                <div className="font-medium text-lg text-white">ALL</div>
                <input
                  type="number"
                  id="amount"
                  inputType="numeric"
                  disabled
                  value={paymentDetails.total}
                  className="inputform border-0 text-heading text-white font-medium text-sm rounded-base block w-full px-3 rounded-lg py-2.5 shadow-xs placeholder:text-body"
                  placeholder={t("AMOUNT_FIELD")}
                  onKeyDown={(e) => {
                    e.target.value = e.target.value.trim();
                  }}
                  {...register("amount", {
                    required: t("AMOUNT_EMPTY"),
                  })}
                  required
                />
              </div>
            </div>

            <div className="text-lg font-medium  mt-5 mb-2">{t("DESCRIPTION")}</div>
            <input
              type="text"
              id="description"
              className="inputform text-heading text-sm rounded-base block w-full px-3 py-2.5 shadow-xs placeholder:text-body"
              onKeyDown={(e) => {
                e.target.value = e.target.value.trim();
              }}
              {...register("comment", {
                required: "",
              })}
            />

            <div className="w-full mt-[5rem]">
              {loading ? (
                <div className="btn btn_theme w-full flex items-center justify-center p-3">
                  <FontAwesomeIcon icon={faCircleNotch} className="text-white text-xl animate-spin" />
                </div>
              ) : (
                <button className="btn btn_theme w-full text-white" type="submit">
                  {t("PAY")}
                </button>
              )}
            </div>
          </div>
        </div>
      </form>

      {showOtpDialog && (
        <OtpDialog
          otpURL={pathObj.pendingSmartfinTransactionSendOTP}
          otpConfirmURL={pathObj.paySmartfinTransaction}
          body={requestBody}
          onSuccess={(message) => {
            navigate("/payments/smartfin");
            notification.success(message || t("OPERATION_SUCCESS"));
          }}
          onClose={() => {
            setShowOtpDialog(false);
          }}
        />
      )}
    </>
  );
}

export default SmartfinPaymentDetails;
